/**
 * Stable tree key for a nested-list item.
 *
 * CourseMenu generates node keys with this helper; AppSidebarSummary must use
 * the same function for Calendar / Folder open targets so they stay in lockstep.
 * Nullish coalescing keeps `id === 0` as a real id (unlike `||`, which would
 * fall through to the index).
 *
 * @param {string} parentKey
 * @param {{ id?: string|number, type?: string }|null|undefined} item
 * @param {number} [index=0]
 * @returns {string}
 */
export function nestedListItemKey(parentKey, item, index = 0) {
    return `${parentKey}-${item?.type || 'item'}-${item?.id ?? index}`;
}
